const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <article className="footer">
      <a
        href="https://github.com/imshubhamchavan/"
        target="_blank"
        rel="noreferrer"
      >
        Copyright &copy; {currentYear} | Shubham Chavan
      </a>
    </article>
  );
};

export default Footer;
